import type { UserManagerSettings } from "oidc-client-ts";

const SCOPE_DEV_FLAG = "ExpertWorkspaceDevTest";

export const getUserManagerSettings = ({
    oidcSsoUrl: authority,
    oidcSsoClientId: client_id,
    oidcSsoAdditionalScope,
    employeeId,
    isDev,
}: {
    oidcSsoUrl: string;
    oidcSsoClientId: string;
    oidcSsoAdditionalScope?: string;
    employeeId?: string;
    isDev?: boolean;
}): UserManagerSettings => {
    const scopes = ["openid", "email", "profile"];
    if (oidcSsoAdditionalScope) scopes.push(oidcSsoAdditionalScope);
    if (employeeId && isDev) scopes.push(`${SCOPE_DEV_FLAG}:${employeeId}`);
    return {
        authority,
        client_id,
        response_type: "code",
        redirect_uri: globalThis.location.origin,
        scope: scopes.join(" "),
    };
};
